import React, {Component} from "react";
import AppWrapper from "./modules/auth/components/AppWrapper";
import Hub from "./modules/hub";
import {Scale} from 'react-scaling';
import TestAssignment from "./modules/games/components/Show/TestAssignment";
import useAuth from "./modules/auth/hooks/useAuth";


import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

function App  (){

  console.log(window.location.href);
  console.log(window.location.pathname);
  const path = window.location.pathname.split('/');
  //split this
  console.log(path);
  //blank / testassignment / servicekey / topics

  if (path.length > 0 && path[1] == "testassignment"){
    console.log("reroute");
    path[3] = path[3].replace(/%22/g, '"');
    console.log(path[3]);
    
    return(
    <TestAssignment
    id={path[2]}
    topics={JSON.parse(path[3]).map(t => t)}
    startImmediately={true}
    //onEnd={() => EndAssignment()}
    testing={true}
    ></TestAssignment>);
  }else{
    return (
      <AppWrapper>
        <ToastContainer 
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        >
          
        </ToastContainer>
        <Hub />
      </AppWrapper>
    );
  }
  
};

export default App;
